import React, { useEffect, useState } from "react";
import LogoutSharpIcon from "@mui/icons-material/LogoutSharp";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import moment from "moment";
import { useTranslation } from "react-i18next";
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { ListRowSkeleton } from "@skeleton";
import PublicIcon from '@mui/icons-material/Public';
import { useNavigate } from "react-router-dom";


const deviceTypeMap = {
  1: "Android App",
  2: "iOS App",
  3: "Web",
};

const ManageSession = () => {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);
  const language = localStorage.getItem("Lang");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const { t } = useTranslation();
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [errorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

    const navigate = useNavigate();
  
    // -------------------------------------------------------------------------
  const { setIsNewsPageLoaded } = useNewsFeedStore();

  useEffect(() => {
    setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

    return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
  }, [setIsNewsPageLoaded]);

  // -------------------------------------------------------------------------

  

  useEffect(() => {
    fetchSessions();
  }, []);

  const fetchSessions = async () => {
    const sessionId = localStorage.getItem("sessionId");
    const token = localStorage.getItem("token");

    if (!sessionId || !token) {
      setErrorToastMessage("Authentication error. Please log in again.");
      setShowErrorToast(true);
      setLoading(false);
      return;
    }
    setLoading(true);

    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };

    try {
      const response = await axios.post(`/Account/ManageSessionInfo`, data);
      setSessions(response.data.responseData);
      // setToastMessage("Sessions loaded successfully.");
      // setShowToast(true);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          setWarningToastMessage(
            error.response.data.message || "No Sessions found."
          );
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(
            error.response.data.message || "Something went wrong."
          );
          setShowErrorToast(true);
        }
      } else {
        setErrorToastMessage("Network error. Please try again.");
        setShowErrorToast(true);
      }
    } finally {
      setLoading(false);
    }
  };

    const [loginHID, setloginHID] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => setShowModal(false);
    const handleShow = () => setShowModal(true);


  const handleLogout = async () => {
    const sessionId = localStorage.getItem("sessionId");

    try {
      const res = await axios.post(
        `/Account/ActiveSessionAction?Action=Logout&LoginHstryId=${loginHID}`,
        { deviceType: "Web", sessionId ,
            langKey: language === "en" ? "" : language,

        }
      );
      console.log("Logout response:", res);
      setToastMessage(res?.data?.message || "Session logged out successfully.");
      setShowToast(true); 
      setSessions((prevSessions) =>
        prevSessions.filter((session) => session.loginHstryId !== loginHID)
      );
      handleCloseModal();

    } catch (error) {
      setErrorToastMessage("Failed to logout session.");
      setShowErrorToast(true);
    }
  };

  const handleLogoutAll = async () => {
    const sessionId = localStorage.getItem("sessionId");

    try {
      const res = await axios.post(
        `/Account/ActiveSessionAction?Action=LogoutAll`,
        {
          deviceType: "Web",
          sessionId,
            langKey: language === "en" ? "" : language,


        }
      );
      setToastMessage(res?.data?.message);
      setShowToast(true);
      setSessions([]);
      setTimeout(() => {
        
        navigate("/SignIn");
      }, 500);
    } catch (error) {
      setErrorToastMessage("Failed to log out all sessions.");
      setShowErrorToast(true);
    }
  };

  const isValidCoordinate = (value) => {
    const normalize = (value) => String(value ?? "").trim().toLowerCase();
    const isInvalid = (value) => {
      const normalized = normalize(value);
      return normalized === "" || normalized === "na" || normalized === "n/a" || normalized === "null" || normalized === "undefined";
    };

    return !isInvalid(value);
  };

  const handleRedirectToMap = (lat, lng) => {
    if (!isValidCoordinate(lat) || !isValidCoordinate(lng)) return;

    const url = `https://www.google.com/maps?q=${lat},${lng}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <div className="setting-header">
        <h4>{t("User Profile.Manage Sessions")}</h4>
      </div>
      <div className=" privacy">
        {loading ? (
          <ListRowSkeleton count={5} rowHeight={50} />
        ) : sessions.length > 0 ? (
          sessions.map((session) => {
            const canRedirectToMap = isValidCoordinate(session.latitude) && isValidCoordinate(session.longitude);

            return (
            <div key={session.loginHstryId}>
              <p className="sessionName">
                {t("User Profile.Location Device Name")} : {deviceTypeMap[session.deviceType] || "Unknown Device"}
              </p>
              <div className="d-flex justify-content-between sessionAction">
               <div className="sessionTime">
                <p className="">
                  {session.deviceType === 3
                    ? `${t("User Profile.IP Address")}: ${session.ipaddress}`
                    : session.deviceInfo}{" "}
                  · {t("User Profile.Since")}{" "}
                  {moment(session.startTime).format("Do MMM YYYY, hh:mm A")}
                </p>
                
              <p
                
                style={canRedirectToMap ? { color: "blue" } : undefined}
               
              ><u className="pointer" onClick={() => {
                  if (canRedirectToMap) {
                    handleRedirectToMap(session.latitude, session.longitude);
                  }
                }}>

                 <span className="f-14"><PublicIcon /> {t("User Profile.Latitude")} : </span> {session.latitude} , <span>{t("User Profile.Longitude")} : </span> {session.longitude}
              </u>
                    </p>
                <p className="">
                 <span>{t("User Profile.Location Device Name")} : </span> {session.loginDeviceName === null ? "NA" : session.loginDeviceName} ,   
                 </p>
                 <p><span>{t("User Profile.Location Name")} : </span> {session.locationName === null ? "NA" : session.locationName}
                    </p>
                </div>
                <LogoutSharpIcon
                  className="material-symbols-sharp pointer"
                  onClick={() => {
                    handleShow();
                    setloginHID(session.loginHstryId);
                  }}
                  // onClick={() => handleLogout(session.loginHstryId)}
                />
              </div>
              <div>
              </div>
            </div>
          );
          })
        ) : (
          <p>{t("User Profile.No active sessions")}</p>
        )}
        <div className="text-end mt-3">
          <button
            type="submit"
            className="btnDanger mt-3 text-center"
            onClick={handleLogoutAll}
          >
            {t("User Profile.Sign out all")}
          </button>
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.Are You Sure You want to Delete?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseModal();
                  }}
                />
              </div>

              <div className="col-md-12 text-end mt-4 d-flex justify-content-center">
                <button
                  type="button"
                  className="closebtn"
                  onClick={() => handleLogout()}
                >
                {t("Drafts.Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

       <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
              />
              <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
              />
              <ErrorToast
                show={showErrorToast}
                message={errorToastMessage}
                onClose={() => setShowErrorToast(false)}
              />

    </>
  );

  
};

export default ManageSession;
